import { handleActions } from 'redux-actions'

import * as TYPES from '../type'

const user = handleActions({
  [TYPES.SET_USER_TOKEN]: (state, { payload: token }) => {
    return {
      ...state,
      token,
      login: true,
    }
  },
}, {
  token: '',
  login: false,
})

export default user



// WEBPACK FOOTER //
// ./src/reducers/user.js